export default __webpack_public_path__ + "static/media/bikram.b1a8de6e.jpg";